/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { forwardRef, useMemo, useState } from 'react';
import { styled } from 'linaria/react';
import InlineSVG from 'react-inlinesvg';
import { SkeletonCir } from '@shared/ui/atoms';
import { getIconSrc } from '@shared/lib/utils/icon';
export interface IconProps extends Omit<React.HTMLAttributes<HTMLOrSVGElement>, 'onError'> {
  /** Имя иконки из библиотеки иконок или путь до кастомной иконки  */
  icon: string;
  /** Флаг указывающий, что иконка не из библиотеки иконок */
  isCustomIcon?: boolean;
  /** Добавляет div как враппер для svg */
  withWrapper?: boolean;
  /** Компонент, который показывается во время загрузки SVG */
  loader?: React.ReactNode;
  /** Размер скелетона, который показывается во время загрузки SVG */
  loaderSize?: number | string;
  /** Коллбек который будет вызван, если при загрузке произойдет ошибка */
  onError?: (error?: Error) => void;
  /** Коллбек который будет вызван, сразу после загрузки иконки */
  onLoad?: () => void;
  /** Функция получающая svg как текст, для преобразования */
  preProcessor?: (arg?: string) => string;
  /** (Svg атрибут) Ширина иконки */
  width?: number;
  /** (Svg атрибут) Высота иконки */
  height?: number;
  /** (Svg атрибут) Границы viewport */
  viewBox?: string;
  /** (Svg атрибут) Цвет иконки */
  color?: string;
  /** (Svg атрибут) Координата по X */
  x?: number;
  /** (Svg атрибут) Координата по Y */
  y?: number;
  size?: 'xl' | 'lg' | 'md' | 'sm';
  fill?: string;
}
const Icon = forwardRef<HTMLElement | SVGElement, IconProps>(({
  icon,
  isCustomIcon = false,
  withWrapper = false,
  loader,
  loaderSize = 16,
  onError,
  onLoad,
  preProcessor,
  width,
  height,
  viewBox,
  color,
  x,
  y,
  className,
  ...rest
}, ref) => {
  const [hasError, setHasError] = useState(false);
  const src = useMemo(() => getIconSrc(icon, isCustomIcon), [icon]);
  const testId = `icon_${icon}`;
  const size = icon ? icon.match(/\d\d(?=\/)/) : false;
  const skeletonSize = size ? size[0] : loaderSize;
  const skeleton = <SkeletonCir height={skeletonSize} data-testid={testId} onClick={rest.onClick} />;
  const handleError = (error: Error) => {
    setHasError(true);
    onError && onError(error);
  };

  /** Костыль, т.к. если в компонент SVG передать undefined, он затрет нативные атрибуты в иконке */
  const svgProps = {
    ...(width && {
      width
    }),
    ...(height && {
      height
    }),
    ...(viewBox && {
      viewBox
    }),
    ...(color && {
      color
    }),
    ...(x && {
      x
    }),
    ...(y && {
      y
    }),
    loader: loader || loader === null ? loader : skeleton,
    onError: handleError,
    onLoad,
    preProcessor
  };
  if (hasError) return skeleton;
  if (withWrapper) {
    return <Wrapper data-testid={testId} ref={ref as React.Ref<HTMLElement>} className={className} {...rest}>
          <Svg src={src} {...svgProps} />
        </Wrapper>;
  }
  return <Svg data-testid={testId} innerRef={ref as React.Ref<SVGElement>} src={src} className={className} {...{
    ...svgProps,
    ...rest
  }} />;
});
const Wrapper = /*#__PURE__*/styled('i')({
  name: "Wrapper",
  class: "wckkrc8",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => InlineSVG as any;
const Svg = /*#__PURE__*/styled(_exp())({
  name: "Svg",
  class: "s64y2x8",
  propsAsIs: true
});
export default Icon;

require("./Icon.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Icon.tsx");